export const environment = {
  production: true,
  dataUrl: 'https://app.predictscreen.com/',
  // dataUrl: 'http://localhost:9886/',
  // TEMP (local testing): revert to qa2 before any real production build.
  dvDataUrl: 'https://prod-app.dvapply.com/',
  // dvDataUrl: 'http://localhost:5090/',
  // dvDataUrl: 'http://localhost:3000/',
  // dataUrl: 'http://192.168.3.212:9886/',
  // dataUrl: 'https://app.predictscreen.com/',
  // dataUrl: 'http://13.68.172.30:9886/',
  googleMapsApiKey: 'AIzaSyAQ59nHdSJ91t6wkF0KcgsgCpn3xr-j1iU'
};
